import { defaultEmployee, EmployeeDto } from 'src/dtos/employee/employeeDto';
import { defaultHrmTrainingDto, HrmTrainingDto } from 'src/dtos/hrmTraining/hrmTrainingDto';
import { defaultHrmTrainingFileDto, HrmTrainingFileDto } from 'src/dtos/hrmTrainingFile/hrmTrainingFileDto';

/** 사원 한 명의 교육·첨부 저장 요청이다. 백엔드 HRM1030_R01Dto와 필드명이 같다. */
export interface HRM1030_R01Dto {
    empNo: string; // 저장 대상 사원번호
    trainYear?: string; // 저장 후 응답 목록에 쓸 교육년도
    trainType?: string; // 저장 후 응답 목록에 쓸 교육구분
    hrmTrainingDtoList: HRM1030_R01TrainingDto[]; // 신규(I)·수정(U) 교육. 첨부 변경도 교육 행 안에 담는다
    deletedHrmTrainingDtoList: HRM1030_R01TrainingDto[]; // D 표시된 저장된 교육
}

/** 조회 전용 사원 행이다. */
export interface HRM1030_R01HeaderDto extends EmployeeDto {
    orgNm: string; // 최신 부서명
    positionNm: string; // 직위명
    empStsNm: string; // 재직상태명
    trainCount: number; // 교육년도 교육 건수
    completeHours: number; // 교육년도 이수(Y) 교육시간 합계
    lawCount: number; // 교육년도 법정의무(T3)·이수(Y) 건수. 2건 미만이면 빨간색
}

/** 공통 그리드의 신규 행 상태를 표현하는 화면 전용 사원 행 타입이다. */
export interface HRM1030_R01HeaderGridRow extends HRM1030_R01HeaderDto {
    inserted?: boolean; // 공통 그리드에서 신규 행인지 판별할 때만 사용
}

/** 교육훈련 이력 행이다. 저장 요청에서는 이 교육의 첨부 변경을 함께 담는다. */
export interface HRM1030_R01TrainingDto extends HrmTrainingDto {
    fileCount: number; // 서버가 센 첨부 수 (조회 전용)
    hrmTrainingFileDtoList?: HRM1030_R01FileDto[]; // 저장 요청 전용: 신규·비고 수정 첨부
    deletedHrmTrainingFileDtoList?: HRM1030_R01FileDto[]; // 저장 요청 전용: D 표시된 저장된 첨부
}

/** 수료증 첨부 행이다. */
export interface HRM1030_R01FileDto extends HrmTrainingFileDto {
    trainingValueIndex: number; // 화면 전용: 이 첨부가 속한 교육 행의 valueIndex (신규 교육 연결용)
    uploadFileData?: string; // 신규 첨부의 Base64(data URL 접두사 제외). 저장 전까지만 보관
}

/** 사원 목록 기본 행이다. 빈 행 채우기와 서버 행의 누락 필드 보완에 쓴다. */
export const defaultHRM1030_R01HeaderDto: HRM1030_R01HeaderDto = {
    ...defaultEmployee,
    orgNm: '',
    positionNm: '',
    empStsNm: '',
    trainCount: 0,
    completeHours: 0,
    lawCount: 0,
};

/** 교육훈련 기본 행이다. 신규 행 추가와 서버 행의 누락 필드 보완에 쓴다. */
export const defaultHRM1030_R01TrainingDto: HRM1030_R01TrainingDto = {
    ...defaultHrmTrainingDto,
    fileCount: 0,
};

/** 첨부 기본 행이다. 신규 첨부 추가와 서버 행의 누락 필드 보완에 쓴다. */
export const defaultHRM1030_R01FileDto: HRM1030_R01FileDto = {
    ...defaultHrmTrainingFileDto,
    trainingValueIndex: 0,
};

/** 빈 저장 요청이다. */
export const defaultHRM1030_R01Dto: HRM1030_R01Dto = {
    empNo: '',
    hrmTrainingDtoList: [],
    deletedHrmTrainingDtoList: [],
};
